import React from "react";
import kitchen_img from "../../Images/kitchen.jpg";
import { useEffect } from "react";
const Kitchen = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto pt-12 pb-6  font-Poppins">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-2 justify-between items-center">
          <div className="w-full lg:w-[48%]">
            <h2 className="text-2xl lg:text-3xl font-semibold py-4">
              Kitchen Installations And Repairs
            </h2>
            <p className="text-lg py-4">
              Reports and forecasts informed us that the impact of inflation is
              phenomenal. At PMC, we have customer interest at the heart of our
              business, and as such, we have various options to meet your needs.
            </p>
            <h2 className="text-2xl lg:text-3xl font-semibold py-4">Design</h2>
            <p className="text-lg ">
              At PMC, we design your kitchen with you while considering your
              needs. We believe your involvement is pivotal to a successful
              design, so we will work with you to ensure that your desired color
              is consistent with the theme of your house and appliances.
            </p>
          </div>
          <div className="w-full lg:w-[48%]">
            <img src={kitchen_img} alt="" className=" w-full rounded-md" />
          </div>
        </div>
        <div className="pt-10 py-8">
          <h4 className="text-2xl lg:text-3xl font-semibold py-4">
            Case Study
          </h4>
          <p className="text-lg py-4">
            Dr MS has a buy-to-let property, and the tenant has not maintained
            the house. The pictures below tell some of the stories. We
            redecorated the whole house and changed the flooring as well. We
            then changed the kitchen units’ frontals and created an additional
            workspace and a breakfast bar using the redundant space in the
            kitchen. We completed this project with 25% of the price of a new
            kitchen. This concept may help you get the best out of your old
            kitchen at minimal costs.
          </p>
          <h4 className="text-2xl lg:text-3xl font-semibold pt-2 pb-4">Supply</h4>
          <p className="text-lg pb-4">
            We consider your budget when determining whether we supply fully
            built or flat-packed units. Irrespective of your decision, we ensure
            that we produce and deliver your kitchen units to a very high
            standard.
          </p>
          <h4 className="text-2xl lg:text-3xl font-semibold pt-2 pb-4">
            Installation
          </h4>
          <p className="text-lg pb-4">
            The installation is perhaps one of the most critical aspects of the
            kitchen experience. Regardless of the quality and attractiveness of
            kitchen units, if the installations or craftmanship are not to a
            very high standard, the expected outlook and the kitchen aesthetics
            would not be complete. We pride ourselves on time spent on
            installations to ensure a great deal of finesse so that you are
            satisfied with the outcome. To this end, guarantee that
            installations would be free of errors and if in the slightness
            chance that something is not right, we will be pleased to resolve it
            at no additional cost on your part for up to 2 years after
            installation.
          </p>
          <h4 className="text-2xl lg:text-3xl font-semibold pt-2 pb-4">
            Appliance Installations
          </h4>
          <p className="text-lg pb-4">
            We install both the appliances that we supply as well as those that
            you supply. We also undertake all the connections to the main supply
            and where necessary like gas, we are happy to issue for you gas
            safety certificate.
          </p>
          <h4 className="text-2xl lg:text-3xl font-semibold pt-2 pb-4">
            Repairs (Remediation)
          </h4>
          <p className="text-lg pb-4">
            Inflation has thought the importance of making new and extending the
            useful life of existing kitchens and appliances. We know that some
            customers might not be able to afford a new kitchen but desired to
            change the look of their kitchen. Hence, we can repair your exiting
            kitchen units while we keep the carcasses and change the frontals,
            decorative panels and the appliances. With this in mind, we might be
            able to create extra storage units and make your kitchen more
            functional. Why not contact us for a repair quotation?
          </p>
        </div>
      </div>
    </div>
  );
};

export default Kitchen;
